import {Component, OnInit, ChangeDetectionStrategy} from "@angular/core"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-loading-spinner-icon",
    templateUrl: "./loading-spinner-icon.component.html",
    styleUrls: ["./loading-spinner-icon.component.scss"],
})
export class LoadingSpinnerIconComponent implements OnInit {
    ngOnInit(): void {}
}
